import React, { useEffect, useState } from "react";
import { CloseIcon } from "../../assets/icons/icons";

const steps = [
  { key: "START", label: "Start" },
  { key: "PROGRESS", label: "Processing" },
  { key: "COMPLETE", label: "Published" },
];

const PublishProgress = ({ status, publishFail, handleHideProgressBar }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [processFail, setProcessFail] = useState(false);

  const getIndexByKey = (key) => steps.findIndex(step => step.key === key);

  useEffect(()=>{
    if(publishFail){
     setProcessFail(true)
    }else{
      const index = getIndexByKey(status);
      if(index != -1) setCurrentStep(index);
    }
  },[publishFail, status])

  return (
    <div className="progress-container editorHeader">
      <div className="stepscount">
        {steps.map((step, index) => (
          <div className="step-container" key={index}>
            <div className={`circle ${processFail ? "publishFail" : index <= currentStep ? "completed" : ""}`}>{ processFail ? "X" : (index < currentStep || steps.length-1 === currentStep) ? "✓" : ""}</div>
            {index !== steps.length - 1 && <div className={`line ${processFail ? "publishFail" : index < currentStep ? "completed" : ""}`} />}
            <div className="step-label">
              <span>{step.label}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="rightbtns">
         <div className="cancelbtn" onClick={handleHideProgressBar}>
           <span><CloseIcon/></span>
         </div>
      </div>
    </div>
  );
};

export default PublishProgress;